import { SearchBox, ISearchBoxProps } from '@fluentui/react/lib/SearchBox';

export interface IPSearchBoxProps extends ISearchBoxProps {}

export const IPSearchBox = (props: IPSearchBoxProps) => {
  return <SearchBox {...props} />;
};